import { Suspense } from "react";
import AppLoading from "../AppLoading";

const SuspenseWrapper = ({ children }: { children: JSX.Element }) => {
  return <Suspense fallback={<AppLoading />}>{children}</Suspense>;
};

export default SuspenseWrapper;
